export const RMlogin = {
  login_url: "client/login",
  otp_verification: "client/otpVerification",
  forget_password: "client/forgetPassword",
  reset_password: "client/private/passwordChange",
  login_mobile: "client/loginMobile",
  login_azure: "azure/clientLogin",
  getBanner: "admin/banner/public/exitsBannerDetails",
  getLanguage: "client/private/languageInfo",
};
export const Users = {
  userList: "client/userList",
  userRegister: "client/register",
  editRegister: "client/userUpdate",
  detailUser: "client/userDetails/",
};
export const Course = {
  getMyCourses: "client/private/my_course",
  getCourseContent: "client/private/my_course/",
  getLearner: "client/private/course/learners",
  getLearnerDetail: "client/private/my_course/learner/details",
  getDepartment: "admin/department/list",
  getDesignation: "admin/designation/list",
  updateLanguage: "client/private/my_course/learner/edit/language",
  updateProfileImage: "client/private/my_course/learner/edit/profileImage",
  learnerUpdate: "client/private/my_course/learner/details/update",
  learnerAdd: "client/private/my_course/learners/add",
  learnerReport: "client/private/my_course/learners/excel_download_key/",
  courseMightInterest: "client/private/courseMightInterest",
  categoryMightInterest: "client/private/categorieMightInterest",
  getLeaderBoard: "client/private/my_course/leaderBoard",
  getBadges: "client/private/my_course/badge/",
  numberLicencePurchases: "client/private/my_course/numberofLicensesPurchased",
  numberLicenceRenewPurchases: "client/private/my_course/renewedLicenses",
  numberOfBatches: "client/private/my_course/noOfBatches",
  coureActivated: "client/private/my_course/courseActivated",
  downloadCertificate: "client/private/my_course/genrateCerficate/",
  getPolicy: "client/private/my_course/policyDocument/",
  getInfo: "client/private/my_course/info/details/",
  createPolicy: "client/private/my_course/createPolicyDocument",
  getLearnerReports: "client/private/my_course/learner/learnerReportGenrate",
  reportGenerate: "client/private/my_course/learners/reportGenrate",
  certiGenerate: "client/private/my_course/genrateCerficateZip",
  deleteLearner: "client/private/my_course/learners/delete",
  deletePolicy: "client/private/my_course/policyDocument/delete",
  sendLearnerMail: "client/private/my_course/sendEmail",
  getImpersonateLink: "client/private/my_course/learner/impersonateRedirect",
  getActiveLog: "client/private/my_course/activeLog",
};
export const HomePageAPI = {
  getDashboardInfo: "client/private/dashboard/info",
};
export const ProfileInfo = {
  getProfileDetails: "client/private/profile/details",
  updateProfile: "client/private/profile/update",
  changePassword: "client/private/profile/changePassword",
  getCompanyDetails: "client/private/companyDetails",
  getNotification: "client/private/listNotifications",
};
export const NotificationAPI = {
  sendNotification: "client/private/my_course/learners/send/Notification",
  sendIndividual: "client/private/my_course/learner/send_notification",
};

export const Categorys = {
  getCategory: "client/private/my_course/categories/list",
};
export const Commiittee = {
  getCommiittee: "client/private/my_course/commitee/list",
  deleteCommiittee: "client/private/my_course/commitee/delete",
  addCommiittee: "client/private/my_course/commitee/create",
  getStatus: "client/private/my_course/commitee/statusInfo/",
  statusUpdate: "client/private/my_course/commitee/statusUpdate",
};
export const ComMember = {
  getComMember: "client/private/my_course/commitee/member/list",
  addComMember: "client/private/my_course/commitee/member/create",
  delComMember: "client/private/my_course/commitee/member/delete",
};
export const SurveyForm = {
  getClientSurevyList: "/clientSurevyList/",
  surveyCreate: "/clientSurevyCreate",
};

export const Feedback = {};
export const ClientGroups = {};
export const Client = {};
export const Industry = {
  getIndustry: "client/private/industry/list",
};
export const Courses = {
  getCategoryCourse: "client/private/my_course/course",
  getEntryCourse: "client/private/my_course/client/courses",
};
export const Reports = {
  // getCourseReport: "client/report/courseWise",
  getCourseReport: "client/private/my_course/report",
  getEntryWise: "client/private/my_course/learners/reportGenrate",
  listReportShedule: "client/private/my_course/listReportSchedule",
  createReportShedule: "client/private/my_course/createReportSchedule",
  deleteReportShedule: "client/private/my_course/deleteReportSchedule",
  entryWiseReport: "client/private/my_course/client/learnerReport",
};
export const Certificate = {
  getCertificate: "client/private/learnerCertificate/list",
  configUpdate: "client/private/config/update",
};
export const GetNotification = {};
export const Learner = {};
export const RaisaTickto = {
  getTickets: "client/private/support-ticket/list",
  createTicket: "client/private/support-ticket/create",
  getIssueType: "client/private/support-ticket/issueType",
};
export const GroupList = {
  getGroupList: "client/private/my_course/filter_group_by",
};